import { costBreakdownV2WidgetByIdSelector } from "./costBreakdownV2WidgetByIdSelector";
import { RootState } from "../../../../../store";
import { resourceExplorerViewsDataSelector } from "../../../../../resource-explorer/selectors/all-resource-explorers/resourceExplorerViewsDataSelector";

export const costBreakdownV2WidgetNotFoundSelector = (
  state: RootState,
  widgetId: string,
) => {
  const widget = costBreakdownV2WidgetByIdSelector(state, widgetId);
  const views = resourceExplorerViewsDataSelector(state);

  if (!widget) {
    return false;
  }

  return !views.find((item) => item.id === widget.view_id);
};
